import TimeSheetModel from 'models/TimeSheetModel';

TimeSheetStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  TimeSheetStore.dispatchCallback,
);

TimeSheetStore.locations = [];
TimeSheetStore.location_ids = [];
TimeSheetStore.punches = [];
TimeSheetStore.break_punches = [];
TimeSheetStore.user = {};

TimeSheetStore.onTimeSheetHandler = function (collection, response) {
  response.timesheets.sort(
    (a, b) => parseFloat(moment(b.starts_at).unix()) - parseFloat(moment(a.starts_at).unix()),
  );

  TimeSheetStore.reset(response.timesheets);
  TimeSheetStore.locations = response.locations;
  TimeSheetStore.location_ids = response.location_ids;
  TimeSheetStore.punches = response.punches;
  TimeSheetStore.break_punches = response.break_punches;
  TimeSheetStore.user = response.user;

  TimeSheetStore.trigger('timesheet:load:success', response);
};

TimeSheetStore.onTimeSheetError = function (error) {
  TimeSheetStore.trigger('timesheet:load:error');
};

TimeSheetStore.getCurrentTimeSheet = function (location_id) {
  const sheets = this.models;
  let currentSheet;
  sheets.forEach((sheet) => {
    sheet = sheet.present();
    const startDate = moment(sheet.starts_at).format();
    const endDate = moment(sheet.ends_at).format();
    const today = moment(Utils.getCurrentDate());
    const between = today.isBetween(startDate, endDate);

    if (
      between
      && sheet.location_id == location_id
      && (typeof currentSheet === 'undefined'
        || moment(currentSheet.starts_at) < moment(sheet.starts_at))
    ) {
      currentSheet = sheet;
    }
  });
  return currentSheet;
};

TimeSheetStore.getPreviousTimeSheets = function (location_id) {
  const sheets = this.models;
  const previousSheets = [];
  sheets.forEach((sheet) => {
    sheet = sheet.present();
    const startDate = moment(sheet.starts_at).format();
    const endDate = moment(sheet.ends_at).format();
    const today = moment(Utils.getCurrentDate());
    const between = today.isBetween(startDate, endDate);

    if (!between && sheet.location_id == location_id) {
      previousSheets.push(sheet);
    }
  });
  return previousSheets;
};

TimeSheetStore.getPunchById = function (id) {
  return _.findWhere(TimeSheetStore.punches, { id });
};

TimeSheetStore.getBreakPunchById = function (id) {
  return _.findWhere(TimeSheetStore.break_punches, { id });
};

TimeSheetStore.getLocationById = function (id) {
  return _.findWhere(TimeSheetStore.locations, { id });
};

TimeSheetStore.onPunchesApprovedHandler = function (collection, response) {
  TimeSheetStore.trigger('timesheet:approve:success', response);
};

TimeSheetStore.onPunchesApprovalError = function (collection, error) {
  TimeSheetStore.trigger('timesheet:approve:error', error);
};
